import React, { useEffect } from 'react';
import { SimpleDialog, ButtonLoading, InputV2 } from 'components';
import { Grid, Button } from '@mui/material';
import Services from '../services';
import { useStylesActiveBonCartDG } from './style';
import { useForm, FormProvider } from 'react-hook-form';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';

export const ActiveBonCartDG = (props) => {
  const { actionActiveBonCartObj, setActionActiveBonCartObj, selectedRow, refreshPage } = props;
  const classes = useStylesActiveBonCartDG();
  const {
    messageTwoTime,
    setMessageTwoTime,
    isLoadingMessage,
    setIsLoadingMessage,
    myInterval,
    setMyInterval,
    isLoading,
    setIsLoading,
  } = useCustomHook();
  const methods = useForm();
  useEffect(() => {
    if (messageTwoTime == 0) {
      clearInterval(myInterval);
      setIsLoadingMessage(false);
    }
    if (!isLoadingMessage) {
      clearInterval(myInterval);
    }
  }, [messageTwoTime]);
  useEffect(() => { }, []);

  const sendMessage = () => {
    setMessageTwoTime(120);
    setIsLoadingMessage(true);
    setActionActiveBonCartObj({ ...actionActiveBonCartObj, step: 2 });
    const p = {
      currencyCode: null,
      pan: selectedRow?.pan,
      userId: selectedRow?.userId,
      walletCode: 'PODLAND_WALLET',
    };
    Services.requestSendMessageAcitveCart(p)
      .then((res) => { })
      .catch((error) => {
        setIsLoadingMessage(false);
        setMessageTwoTime(0);
        clearInterval(myInterval);
      });
    setMyInterval(
      setInterval(() => {
        //;
        setMessageTwoTime((prevCount) => prevCount - 1);
      }, 1000),
    );
  };

  const sabt = (value) => {
    const p = {
      cellphoneNumber: value?.phoneNumber,
      code: value?.code,
    };
    setIsLoading(true);
    Services.requestAcitveCart(p)
      .then((res) => {
        createToast('موفق', 'عملیات باموفقیت انجام شد.', 'success');

        setActionActiveBonCartObj({ ...actionActiveBonCartObj, isShowDialog: false, step: 1 });
        refreshPage();
      })

      .finally((e) => {
        setIsLoading(false);
      });
  };
  const closeDialog = () => {
    setActionActiveBonCartObj({ ...actionActiveBonCartObj, isShowDialog: false });
    setTimeout(() => {
      setActionActiveBonCartObj({ ...actionActiveBonCartObj, isShowDialog: false, step: 1 });
    }, 100);
  };
  return (
    <SimpleDialog title="فعالسازی کارت" open={actionActiveBonCartObj.isShowDialog}>
      {actionActiveBonCartObj.step == 1 && (
        <Grid item style={{ margin: '0 4px' }}>
          آیا از فعالسازی کارت برای " {selectedRow?.name} "  اطمینان دارید؟
        </Grid>
      )}
      {actionActiveBonCartObj.step == 2 && (
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(sabt)} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid
                direction="row"
                style={{ display: 'flex', flexDirection: 'row' }}
                spacing={3}
                container
                item
                xs={12}
                md={12}
                lg={12}
              >
                <Grid item md={8} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="ورود شماره موبایل دریافت کننده پیامک"
                    name="phoneNumber"
                    register={methods.register}
                    rules={['required', 'isMobile']}
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: '-30px',
                  }}
                >
                  <Grid item md={8} xs={12}>
                    <InputV2
                      fullWidth
                      errors={methods.formState.errors}
                      label="ورود شماره کد ارسال شده"
                      name="code"
                      register={methods.register}
                      rules={['required', 'isNumeric']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={4}
                    style={{ display: 'flex', alignItems: 'center', margin: '0 6px' }}
                  >
                    {isLoadingMessage && (
                      <span style={{ marginTop: '18px', marginRight: '8px' }}>
                        {messageTwoTime}
                      </span>
                    )}
                    {!isLoadingMessage && messageTwoTime == 0 && (
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ marginTop: '16px', marginRight: '4px', height: '37px !important' }}
                        onClick={sendMessage}
                      >
                        ارسال مجدد
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid direction="row" container item xs={12} justifyContent='flex-end'>

                <ButtonLoading
                  type="submit"
                  variant="contained"
                  color="primary"
                  loading={isLoading}
                  disabled={isLoading}
                  name="ثبت"
                />
                <Button
                  variant="contained"
                  onClick={() => {
                    closeDialog();
                    clearInterval(myInterval);
                  }}
                  style={{ margin: '0 4px' }}>
                  انصراف
                </Button>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      )}
      {actionActiveBonCartObj.step == 1 && (
        <Grid item style={{ marginTop: '8px' }}>
          <ButtonLoading
            type="submit"
            variant="contained"
            color="primary"
            name={actionActiveBonCartObj.step == 2 ? 'ثبت' : 'بله'}
            onClick={sendMessage}
            style={{ margin: '0 4px' }}
          />

          <Button variant="contained" onClick={closeDialog}>
            {actionActiveBonCartObj.step == 2 ? 'انصراف' : 'خیر'}
          </Button>
        </Grid>
      )}
    </SimpleDialog>
  );
};
